import styled from "styled-components";

import theme from "config/theme";

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 0 20px 20px;
  max-width: 1440px;
  display: flex !important;
  flex-direction: column;
  text-align: center;

  & > div {
    justify-content: center;
  }
`;

export const Description = styled.p`
  width: 100%;
  margin: 10px auto;
  color: ${theme.color.gray2};
  font-size: ${theme.font.size.delta};

  p {
    margin: 0;
  }
`;
